import { render, staticRenderFns } from "./monthly_profit.vue?vue&type=template&id=330162d0&scoped=true&"
import script from "./monthly_profit.vue?vue&type=script&lang=js&"
export * from "./monthly_profit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330162d0",
  null
  
)

export default component.exports